var app = angular.module('leonardo');

var ReportsStatisticList = function($scope, $controller, $filter, ReportService, FilterService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('Dynamic Form Statistic Reports');
  $scope.report_type = ReportService.TYPE_DYNAMIC_FORM_STATISTIC;
  $scope.fieldsReport = ReportService.fieldsStatisticReport;

  $scope.resetFields = function(){
    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else {
      $scope.fields_active = [];
      angular.forEach($scope.fieldsReport, function(value) {
        $scope.fields_active.push(value.id);
      });
    }
    var group_by = FilterService.getFilter('group_by');
    if (_.contains($scope.fields_active, group_by)) {
      $scope.fields_active.splice($scope.fields_active.indexOf(group_by), 1);
    }
  };

  $scope.getFieldClasses = function(field){
    var classes = [];
    switch (field) {
      case 'name': classes.push('field-name');
        break;
      case 'section_score':
      case 'section_status':
        classes.push('date-multi-head');
        break;
    }
    return classes;
  };

  $scope.getFieldValue = function(report, field) {
    var html = '';
    switch(field) {
      case 'account':
      case 'portfolio':
      case 'property':
        return report[field] ? report[field].name : '';
      case 'status':
        return report[field] ? $filter('workflowStatus')(report[field]) : '';
      case 'section_score':
        html = '';
        if (angular.isArray(report['dfd_summary'])) {
          angular.forEach(report['dfd_summary'], function(element){
            html += '<span><b>DF:</b> ' + element.name + ' - <b>Score:</b> ' + element.score + '</span>';
          });
        }
        else {
          html = report['dfd_summary'] ? '<span><b>DF:</b> ' + report['dfd_summary'].name + ' - <b>Score:</b> ' + report['dfd_summary'].score + '</span>' : '';
        }
        return html;
      case 'section_status':
        html = '';
        if (angular.isArray(report['dfd_summary'])) {
          angular.forEach(report['dfd_summary'], function(element){
            html += '<span><b>DF:</b> ' + element.name + ' - <b>Status:</b> ' + element.status + '</span>';
          });
        }
        else {
          html = report['dfd_summary'] ? '<span><b>DF:</b> ' + report['dfd_summary'].name + ' - <b>Status:</b> ' + report['dfd_summary'].status + '</span>' : '';
        }
        return html;
      case 'portfolio_id':
        return report.portfolio.id;
      case 'property_id':
        return report.property.id;
      case 'action_item_ids':
        html = '';
        report.action_items.map(ai => ai.id).forEach(function(value){
          html += '<p>'+value+'</p>';
        });
        return html;
      default: return report[field];
    }
  };

  $scope.getIndexWorkflow = function(id, workflow_id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped[$scope.getIndex(id)].workflows, function(value, key){
      if (value.id == workflow_id) {
        index = key;
      }
    });
    return index;
  };

  $scope.groupReports = function(data) {
    if (data.results){
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }
    $scope.reportsGrouped = [];

    var id = 'ungroup';
    var name = 'Ungroup';
    var array_by_name = [];
    switch (FilterService.getFilter('group_by')) {
      case 'account':
        angular.forEach($scope.accounts_by_name, function (account) {
          if (getIndexArray(array_by_name, account.id) < 0) {
            array_by_name.push({id: account.id, name: account.name});
          }
        });
        break;
      case 'portfolio':
        angular.forEach($scope.portfolios_by_name, function (portfolio) {
          if (getIndexArray(array_by_name, portfolio.id) < 0) {
            array_by_name.push({id: portfolio.id, name: portfolio.name});
          }
        });
        break;
      case 'property':
        angular.forEach($scope.properties_by_name, function (property) {
          if (getIndexArray(array_by_name, property.id) < 0) {
            array_by_name.push({id: property.id, name: property.name});
          }
        });
        break;
    }
    angular.forEach($scope.reports, function(value) {
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          else {
            id = 'no_account';
            name = 'No account';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
          }
          else {
            id = 'no_portfolio';
            name = 'No portfolio';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
          }
          else {
            id = 'no_property';
            name = 'No property';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              if(FilterService.hasFilter('group_reports')){
                if(_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())){
                  id.push(group.id);
                  name.push(group.name);
                  array_by_name.push({id: group.id, name: group.name});
                }
              }else{
                id.push(group.id);
                name.push(group.name);
                array_by_name.push({id: group.id, name: group.name});
              }
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)){
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({id: manager.id, name: manager.name});
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name.push({id: value.managed_by.id, name: value.managed_by.name});
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name.push({id: id, name: name});
          }
          break;
      }
      if (angular.isArray(id)){
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, workflows: []});
          }
          if ($scope.getIndexWorkflow(value_manager.id, value.workflow.id) < 0) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].workflows.push({id:value.workflow.id, reports: [], name: value.name });
          }
          if (getIndexArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].workflows[$scope.getIndexWorkflow(value_manager.id, value.workflow.id)].reports, value.id) < 0) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].workflows[$scope.getIndexWorkflow(value_manager.id, value.workflow.id)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, workflows: []});
        }
        if ($scope.getIndexWorkflow(id, value.workflow.id) < 0) {
          $scope.reportsGrouped[$scope.getIndex(id)].workflows.push({id:value.workflow.id, reports: [], name: value.name });
        }
        if (getIndexArray($scope.reportsGrouped[$scope.getIndex(id)].workflows[$scope.getIndexWorkflow(id, value.workflow.id)].reports, value.id) < 0) {
          $scope.reportsGrouped[$scope.getIndex(id)].workflows[$scope.getIndexWorkflow(id, value.workflow.id)].reports.push(value);
        }
      }

    });
    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
    else {
      $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
    }
  };
};

app.controller('ReportsStatisticList', ['$scope', '$controller', '$filter', 'ReportService', 'FilterService', ReportsStatisticList]);
